<template>
	<div
		:class="['panel', 'donation_about',
			isHeaderIndent? 'mt-0 pt-1' : '',
			isFooterIndent? 'mb-0 pb-1' : '',

		]"
	>
		<div class="container"
			:class="[
				'panel_header',
				isBrand? 'sk' : '',
			]"		
		>
			<div class="row">
				<div class="col-12 col-lg-6">
					<div
						v-if="isHeaderVisible"
					>
						<h2>{{ block.block_title }}</h2>
					</div>
					<div v-if="'short_description' in block.content" class="title">
						{{ block.content.short_description.ru }}
					</div>
				</div>
				<div class="col-12 col-lg-5 offset-lg-1">
					<div
						v-if="'description' in block.content"
						class="overview"
						v-html="block.content.description.ru"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import panel from '~/mixins/panel';

export default {
	name: 'DonationAbout',
	mixins: [panel],
};
</script>

<style lang="scss" scoped>
	@import "~/assets/styles/components/dev/donation-about";
</style>
